import { subDays } from 'date-fns';

// Latest date a user may select across date-range pickers.
// Today's ad metrics are still accumulating, so selection and defaults cap at yesterday.
export const getLatestSelectableDate = () => subDays(new Date(), 1);
